export class IdNormalizer {
  constructor(private readonly target: { _id?: string; id?: string }) {}

  value() {
    return String(this.target._id || this.target.id);
  }
}
